import { Injectable } from "@angular/core";
import { FilterData } from "../_shared/dialog/filter-select-dialog/filter-select-dialog.component";

export class SubjectFilter {
  subjectModelId: string;
  subjectId: string;
  owner: string;
  country: string;
  state: string;
  district: string;
  site: string;
  project: string;

  constructor(
    subjectModelId: string,
    subjectId: string,
    owner: string,
    country: string,
    state: string,
    district: string,
    site: string,
    project: string
  ) {
    this.subjectModelId = subjectModelId;
    this.subjectId = subjectId;
    this.owner = owner;
    this.country = country;
    this.state = state;
    this.district = district;
    this.site = site;
    this.project = project;
  }
}

export interface QueryParam {
  filter: { status: string; subjectFilter: SubjectFilter; isOwn: boolean; labels: FilterData[] };
  sort: { active: string; direction: string };
  page: { index: number; size: number };
}
export interface ReportQueryParam {
  filter: { status: string; subjectFilter: SubjectFilter; isOwn: boolean; labels: FilterData[] };
  sort: { active: string; direction: string };
  page: { index: number; size: number };
  search: { text: string };
}
export interface ReportDisplayParam {
  isShowPastReports: boolean;
}
export interface ReportSelectQueryParam extends ReportQueryParam {
  filter: { status: string; subjectFilter: SubjectFilter; isOwn: boolean; labels: FilterData[]; isSelectedOnly: boolean };
  sort: { active: string; direction: string };
  page: { index: number; size: number };
  search: { text: string };
}

export interface InspectionDataQueryParam {
  filter: { markId: number[] };
  sort: { item: string };
  subjectImageOpen: boolean;
  printScreenValue: string;
}

export interface InspectionIdQueryParam {
  inspectionId: string[];
}

export interface SettingSubjectQueryParam {
  subjectImageOpen: boolean;
}

export interface RetouchSettingsQueryParam {
  fill: { isFill: boolean; color: string };
  border: { strokeWidth: number; color: string };
}

export const INSPECTON_LIST___QUERY_PARAMS = "inspection_list___query_param";
export const INSPECTON_REPORT_LIST___REPORT_QUERY_PARAMS = "inspection_report_list___report_query_param";
export const INSPECTION_REPORT___DISPLAY_PARAMS = "inspection_report___display_param";
export const INSPECTION_DATA_MANAGEMENT___INSPECTION_DATA_PARAMS = "inspection_data_management___inspection_data_param";
export const INSPECTION_DATA_MANAGEMENT___INSPECTION_ID_PARAMS = "inspection_data_management___inspection_id";
export const SETTINGS_SUBJECT___QUERY_PARAMS = "settings_subject___query_param";
export const INSPECTION___PAST_REPORT_FILTER_PARAM = "inspection___past_report_filter_param";
export const INSPECTION_IMAGE__RETOUCH_SETTING_QUERY_PARAMS = "inspection_image__retouch_setting_query_param";
export const CURRENT_LANGUAGE = "current_language";

@Injectable()
export class StorageService {
  constructor() {}

  pushQueryParam(key: string, queryParam: QueryParam): void {
    sessionStorage.setItem(key, JSON.stringify(queryParam));
  }

  fetchInspectionDataParam(key: string): InspectionDataQueryParam {
    const json = sessionStorage.getItem(key);
    if (!json) {
      return null;
    }
    return JSON.parse(json);
  }

  fetchCurrentLanguage(): string {
    return sessionStorage.getItem(CURRENT_LANGUAGE);
  }

  pushCurrentLanguage(language: string): void {
    sessionStorage.setItem(CURRENT_LANGUAGE, language);
  }

  pushInspectionDataParam(key: string, inspectionDataParam: InspectionDataQueryParam): void {
    sessionStorage.setItem(key, JSON.stringify(inspectionDataParam));
  }

  fetchInspectionIdParam(key: string): InspectionIdQueryParam {
    const json = sessionStorage.getItem(key);
    if (!json) {
      return null;
    }
    return JSON.parse(json);
  }

  pushInspectionIdParam(key: string, inspectionIdParam: InspectionIdQueryParam): void {
    sessionStorage.setItem(key, JSON.stringify(inspectionIdParam));
  }

  fetchReportQueryParam(key: string): ReportQueryParam {
    const json = sessionStorage.getItem(key);
    if (!json) {
      return null;
    }
    return JSON.parse(json);
  }

  pushReportQueryParam(key: string, reportQueryParam: ReportQueryParam): void {
    sessionStorage.setItem(key, JSON.stringify(reportQueryParam));
  }

  fetchSettingSubjectQueryParam(key: string): SettingSubjectQueryParam {
    const param = sessionStorage.getItem(key);
    if (!param) {
      return null;
    }
    return JSON.parse(param);
  }

  pushSettingSubjectQueryParam(key: string, param: SettingSubjectQueryParam) {
    sessionStorage.setItem(key, JSON.stringify(param));
  }

  fetchPastReportFilterParam(key: string): string {
    const param = sessionStorage.getItem(key);
    if (!param) {
      return null;
    }
    return JSON.parse(param);
  }

  pushPastReportFilterParam(key: string, param: string) {
    sessionStorage.setItem(key, JSON.stringify(param));
  }

  /** レポート表示画面の画面情報を取り出す
   * @param  {string} key
   * @returns void
   */
  fetchReportDisplayParam(key: string): ReportDisplayParam {
    const json = sessionStorage.getItem(key);
    if (!json) {
      return null;
    }
    return JSON.parse(json);
  }

  /** Retouch画面のスタイル情報を取り出す
   * @param  {string} key
   * @returns void
   */
  fetchRetouchSettingQueryParam(key: string): RetouchSettingsQueryParam {
    const json = sessionStorage.getItem(key);
    if (!json) {
      return null;
    }
    return JSON.parse(json);
  }

  /** Retouch画面のスタイル情報を内部ストレージに格納する
   * @param  {string} key
   * @param  {RetouchSettingsQueryParam} retouchSettingsQueryParam
   * @returns void
   */
  pushRetouchSettingQueryParam(key: string, retouchSettingsQueryParam: RetouchSettingsQueryParam): void {
    sessionStorage.setItem(key, JSON.stringify(retouchSettingsQueryParam));
  }
}
